<p-dropdown
    class="w-100"
    styleClass="w-100"
    inputStyleClass="w-100"
    appendTo="body"
    dataKey="classId"
    optionLabel="courseName"
    [filter]="showFilter"
    filterBy="courseName"
    [placeholder]="placeholder"
    [showClear]="showClear"
    [options]="classes"
    [(ngModel)]="selected"
    (ngModelChange)="onSelectionChange()">

    <ng-template let-item pTemplate="item">

        <div class="d-flex flex-row justify-content-start align-items-center">

            <div class="d-flex flex-column justify-content-center align-items-center">
                <span class="material-icons me-2" [ngClass]="getOccupancyPercentageClass(item)">lens</span>
            </div>

            <div class="d-flex flex-column justify-content-start align-items-start">
                <span class="fw-bold">{{ item.courseName }} [{{ item.classification.name }}]</span>
                <span class="fw-light">{{ getFreePlacesText(item) }}</span>
            </div>

        </div>

    </ng-template>

</p-dropdown>
